// src/data/serumsImg/selectiveCareImg.js

export const selectiveImages = {
  imgBanner: require("../../img/jetCare-serums/Opening_pages__Selective.png"),
  imgModal: require("../../img/jetCare-serums/Selective Care_Set.png"),
  productsImages: {
    "growth-factor": {
      image: require("../../img/jetCare-serums/selective_gf.14.png"),
      imageBig: require("../../img/jetCare-serums/Growth_factor_selective.png")
    },
    "argireline-complex": {
      image: require("../../img/jetCare-serums/selective_arc.16.png"),
      imageBig: require("../../img/jetCare-serums/Selective Care – Argireline.png")
    },
    "clear": {
      image: require("../../img/jetCare-serums/Selective_C.15.png"),
      imageBig: require("../../img/jetCare-serums/Clear.png")
    },
    "scalp-hair": {
      image: require("../../img/jetCare-serums/selective_sh.11.png"),
      imageBig: require("../../img/jetCare-serums/Scalp & Hair.png")
    },
    "soothing": {
      image: require("../../img/jetCare-serums/Selective_S.12.png"),
      imageBig: require("../../img/jetCare-serums/Soothing.png")
    },
    "lightening": {
      image: require("../../img/jetCare-serums/selective_l.13.png"),
      imageBig: require("../../img/jetCare-serums/Lightening.png")
    }
  }
};
